const experience = {
  header: {
    overline: "PROFESSIONAL JOURNEY",
    titlePrefix: "Building",
    titleHighlight: "Excellence",
    titleSuffix: "Through Experience",
    subtitle:
      "A track record of delivering high-impact AI solutions and robust digital architectures across diverse industries.",
  },
  current: "Current",
  present: "Present",
  sections: {
    technologies: "Key Technologies",
    skills: "Professional Skills",
  },
  footer: {
    titlePrefix: "Transforming Experience into",
    titleHighlight: "Competitive Advantages",
    subtitle:
      "My diverse background allows me to bridge the gap between technical complexity and business value, ensuring that AI projects are not just research, but robust market products.",
    downloadCv: "Download Full CV",
  },
};

export default experience;
